import { useEffect, useState } from 'react';
import { getCurrentUser, logout, type AuthenticatedUser } from '@/api/auth';
import { ApiError, AUTH_EXPIRED_EVENT } from '@/api/http';
import AccessDeniedScreen from '@/components/AccessDenied/AccessDeniedScreen';
import ChatWidget from '@/components/ChatWidget/ChatWidget';
import LoginScreen from '@/components/Login/LoginScreen';
import UserBadge from '@/components/Login/UserBadge';
import './App.css';

function App() {
  const [user, setUser] = useState<AuthenticatedUser | null>(null);
  const [checkingSession, setCheckingSession] = useState(true);
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    const handleAuthExpired = () => setUser(null);
    window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);

    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
  }, []);

  useEffect(() => {
    getCurrentUser()
      .then((currentUser) => {
        setUser(currentUser);
        setAccessDenied(false);
      })
      .catch((error: unknown) => {
        if (error instanceof ApiError && error.status === 403) {
          setAccessDenied(true);
          return;
        }
        throw error;
      })
      .finally(() => setCheckingSession(false));
  }, []);

  const handleLogout = async () => {
    await logout();
    setUser(null);
  };

  if (checkingSession) {
    return <div className="app-loading" />;
  }

  if (!user) {
    if (accessDenied) {
      return <AccessDeniedScreen />;
    }
    return <LoginScreen />;
  }

  return (
    <div className="app">
      <ChatWidget headerExtra={<UserBadge user={user} onLogout={() => void handleLogout()} />} />
    </div>
  );
}

export default App;
